import { useState, useEffect } from "react";
import axios from "axios";
import useAxiosConfig from "../../../../config/useAxiosConfig";

const useAppsTesting = (schoolId) => {
  const { loading: axiosLoading, error, postData: apiPost } = useAxiosConfig();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/AdminAppTestingMember/${schoolId}`);
        setData(response.data?.rows || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    if (!axiosLoading) {
      fetchData();
    }
  }, [axiosLoading]);

  const postData = async (newData) => {
    try {
      const postData = {
        jsStruct: JSON.stringify(newData),
      };
      const response = await axios.post("/TestingRequest", postData);
      setData((prevData) => [...prevData, response.data]);
      return response.data;
    } catch (error) {
      console.error("Error adding data:", error);
      throw error;
    }
  };

  return {
    data,
    loading,
    postData,
  };
};

export default useAppsTesting;
